import { trackEvent } from '@farmnet/tag-manager';

angular.module('cfn').controller('cropController', cropController);

cropController.$inject = [
  '$scope',
  'notificationService',
  'farmnet.FeatureToggleService'

];
function cropController(
  $scope,
  notificationService,
) {
  $scope.hasModule = app.hasModule;
  $scope.hasRight = app.hasRight;
  $scope.currencyUnit = app.credentials.company.currencyUnit;
  $scope.hasFunctionalAnalysisRight = app.hasRight('Company:FUNCTIONAL_ANALYSIS');
  $scope.hasCompanyPlanningRight = app.hasRight('Company:PLANNING');
  $scope.hasPreliminaryBookingRight = app.hasRight(
    'Company:PRELIMINARY_BOOKING'
  );


  $scope.state = {};

  function unreadBookingsChange(value) {
    $scope.unreadOperations = value;
  }
  notificationService.subscribe(
    notificationService.services().UNREAD_FIELD_BOOKINGS,
    unreadBookingsChange
  );

  $scope.trackCropNavigation = (title) => { // to be changed ?
    const navigationLabel = `Crop::${title}`;

    trackEvent('Navigation', 'Body', navigationLabel);
  };

  return ($scope.cropController = this);
}
